<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-3">
        <anosafra-multiselect
          v-model="anosafra"
          label="Ano Safra"
          :clearable="false"
        >
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <badge class="badge-dot" type v-if="props.option.is_open">
                <i class="bg-success"></i>
              </badge>
              <badge class="badge-dot" type v-else>
                <i class="bg-danger"></i>
              </badge>
              <span class="option__title"> {{ props.option.descricao }}</span>
            </div>
          </template>
        </anosafra-multiselect>
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Cargo</label>
        <multiselect
          v-model="selectedSalesmanJobInterface"
          :options="filteredJobs"
          placeholder="Escolha um cargo"
          label="label"
          track-by="value"
          :key="selectedSalesmanJob ? selectedSalesmanJob.value : selectedSalesmanJob"
          @input="toggleRoles($event)"
        />
      </div>
      <div class="col-md-6">
        <label class="form-control-label">
          {{ this.title == 'Vegetal' || this.title == "" ? 'Vendedor' : this.title }}
        </label>
        <multiselect
          v-if="enabledSalesmanFilter"
          filterable
          :options="users"
          :loading="isLoadingSalesmans"
          v-model="selectedSalesman"
          :placeholder="'SELECIONAR ' + this.title"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          label="name"
          track-by="id"
          @search-change="handleInputSearch"
        />        
        <base-input
          v-else
          :value="this.$root.$data.currentUser.name || selectedSalesman.name"
          :disabled="true"
        >
        </base-input>
      </div>
    </div>
    <div class="row" >
      <div class="col-md-3">
        <label class="form-control-label">Marca</label>
        <multiselect
          v-model="filter.id"
          filterable
          :options="brands"
          placeholder="Ex: A. Azevedo"
          label="name"
          track-by="id"
        />
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Grupo</label>
        <multiselect
          v-model="filter.group_id"
          filterable
          :options="groups"
          placeholder="Ex: Sementes"
          label="descricao"
          track-by="id"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
        />
      </div>
      <div class="col-md-6">
        <label class="form-control-label">Produto</label>
        <base-input>
          <input
            class="form-control"
            @keyup.enter="setPreferredName()"
            v-model="preferredname"
            type="text"
            placeholder="Digite o nome do produto"
            aria-describedby="button-addon2"
          />
        </base-input>
      </div>

      <div class="col-12" v-if="!(loadingAnosafraUsers || elabledSalesmanGoals)">
        <p class="text-red text-center mb-0">
          Vendedor não cadastrado no ano safra selecionado
        </p>
      </div>
    </div>
    <div slot="footer" class="row justify-content-end mr-1">
        <base-button
          type="secondary"
          class="mr-2 mt-2"
          @click="clearFilters">
            Limpar Filtros
        </base-button>
        <base-button
          type="primary"
          class="mr-2 mt-2"
          :disabled="!(loadingAnosafraUsers || elabledSalesmanGoals)"
          @click="onSubmit"><i class="fas fa-filter"></i>
            Filtrar
        </base-button>
      </div>
  </div>
  
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";


import { Select, Option, Loading } from "element-ui";
export default {
  name: "filter-goals",
  components: {
    Multiselect,
    AnosafraMultiselect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {   
    getBrands: {
      type: Function
    },
    anosafra: {
      type: Object,
      description:
        "Anosafra a ser sincronizado com a opção do seletor de anosafra",
      default: () => {},
    },
    selectedSalesmanJob: {
      type: Object,
    },
  },
  data() {
    return {
      searchManagersTimeout: null,
      filter: {
        preferredproduct_name: "",
      },
      brands: [],
      groups: [],
      users: [],
      preferredname: null,
      isGeneralGoals: false,
      salesman: {},
      anosafras: [],
      isLoadingSalesmans: false,
      loadingAnosafraUsers: true,
      title: "",
      jobs: [],
      clearNow: false,
      anosafraUsers: [],
    };
  },
  mounted() {
    this.getGroups();
    this.getBrandsNames();

    if (!this.enabledSalesmanFilter) {
      this.selectedSalesmanJobInterface = { label: 'Vendedores', value: 'salesman' }
    }
  },
  methods: {
    clearFilters(){
      this.preferredname = '';
      this.filter.id = '';
      this.filter.group_id = '';
      this.selectedSalesmanJob = ''
      if (this.clearNow == true) {
        this.clearNow = false

        if (!this.elabledSalesmanGoals) return

        this.getBrands(null , {id: 0})
      }
    },
    onSubmit() { 
      if (!this.elabledSalesmanGoals) return

      this.clearNow = true;
      this.setPreferredName();
      this.getBrands(null, {
        id: this.filter.id ? this.filter.id.id : null,
        group_id: this.filter.group_id ? this.filter.group_id.id : null,
        preferredproduct_name: this.filter.preferredproduct_name ? this.preferredname : null,
      }
    );   
    },
    async getAnosafraUsers() {
      this.loadingAnosafraUsers = true;
      try {
        const response = await this.$http.secured.get(`/api/v1/anosafra_user`, {
          params: {
            q: {
              anosafra_id: this.anosafra.id,
              salesman_id: this.selectedSalesman.id,
            },
          },
        });
        this.anosafraUsers = response.data.anosafra_users || [];

        this.$nextTick(() => {
          this.$emit("update:elabled-salesman-goals", this.elabledSalesmanGoals);
        })
      } catch (error) {
        console.error("[FilterGoals][getAnosafraUsers]", error);
      }
      this.loadingAnosafraUsers = false;
    },
    setPreferredName() {
      this.filter.preferredproduct_name = this.preferredname;
    },
    getGroups() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.groups = response.data;
      });
    },
    getBrandsNames() {
      this.$http.secured
        .get("/api/v1/brands/", {
          params: {
            unpaged: true,
          },
        })
        .then((response) => {
          this.brands = response.data;
        });
    },
    checkAdminUser() {
      return this.$currentUser().is_admin;
    },
    toggleRoles(type) {
      switch (type.value) {
        case "admin":
          this.getSalesmans();
          this.title = type.label
          this.isGeneralGoals = true
          // this.$emit("salesman", { name: "VEGETAL", id: 0 });
          break;
        case "mkt":
          this.getMktManagers();
          this.title = type.label
          this.isGeneralGoals = false
          break;
        case "coordinator":
          this.getCoordinators();
          this.title = type.label
          this.isGeneralGoals = false
          break;
        case "manager":
          this.getManagers();
          this.title = type.label
          this.isGeneralGoals = false
          break;
        case "seed_manager":
          this.getSeedManagers();
          this.title = type.label
          this.isGeneralGoals = false
          break;
        case "seed_coordinator":
          this.getSeedCoordinators();
          this.title = type.label
          this.isGeneralGoals = false
          break;
        default:
          this.getSalesmans();
          this.title = type.label
          this.isGeneralGoals = false
          break;
      }
    },
    getManagers(name) {
      this.isLoadingSalesmans = true;
      const anosafra_id = this.anosafra.id
      this.$http.secured
        .get("/api/v1/users", { params: { q: { is_manager: true, anosafra_id: anosafra_id ? anosafra_id : null, status: true, name: name }}})
        .then((response) => { 
          this.users = response.data.users;
          if (this.$currentUser().is_manager && !this.$currentUser().is_mkt_manager && !this.$currentUser().is_coordinator && !this.$currentUser().is_admin) {
            this.users = this.users.filter((user) => user.id == this.$currentUser().id)
          } else if (this.$currentUser().is_mkt_manager && !this.$currentUser().is_admin) {
            this.users = this.users.filter(user => this.$currentUser().mkt_manager_id.includes(user.id))
          } else if (this.$currentUser().is_coordinator && !this.$currentUser().is_admin) {
            this.users = this.users.filter(user => this.$currentUser().coordinated_ids.includes(user.id))
          }
          this.isLoadingSalesmans = false;
        })
        .catch((error) => console.error("[FilterGoals][getManagers]", error));
    },
    handleInputSearch(name) {
      if (this.selectedSalesmanJobInterface.value === 'manager') {
        if (this.searchManagersTimeout) {
          clearTimeout(this.searchManagersTimeout);
        }
        this.searchManagersTimeout = setTimeout(() => {
          this.getManagers(name);
        }, 500);
      }
    },
    getSeedManagers() {
      this.isLoadingSalesmans = true;
      this.$http.secured
        .get("/api/v1/users/", { params: { unpaged: true, q: {is_seed_manager: true, anosafra_id: this.anosafra ? this.anosafra.id : null }}})
        .then((response) => {
          this.users = response.data;
          if (this.$currentUser().job != null && this.$currentUser().job[0].value === 'seed_manager' && !this.$currentUser().is_admin) {
            this.users = this.users.filter((user) => user.id == this.$currentUser().id)
          }
          this.isLoadingSalesmans = false;
        })
        .catch((error) => console.error("[FilterGoals][getSeedManagers]", error));
    },
    getSeedCoordinators() {
      this.isLoadingSalesmans = true;
      this.$http.secured
        .get("/api/v1/users/", { params: { unpaged: true, q: {is_seed_coordinator: true, anosafra_id: this.anosafra ? this.anosafra.id : null }}})
        .then((response) => {
          this.users = response.data;
          if (this.$currentUser().job != null && this.$currentUser().job[0].value === 'seed_coordinator' && !this.$currentUser().is_admin) {
            this.users = this.users.filter((user) => user.id == this.$currentUser().id)
          }
          this.isLoadingSalesmans = false;
        })
        .catch((error) => console.error("[FilterGoals][getSeedCoordinators]", error));
    },
    getCoordinators() {
      this.isLoadingSalesmans = true;
      this.$http.secured
        .get("/api/v1/users/", { params: { unpaged: true, q: { is_coordinator: true, anosafra_id: this.anosafra ? this.anosafra.id : null }}})
        .then((response) => { 
          this.users = response.data;
          if (this.$currentUser().is_coordinator && !this.$currentUser().is_admin) {
            this.users = this.users.filter((user) => user.id == this.$currentUser().id)
          }
          this.isLoadingSalesmans = false;
        })
        .catch((error) => console.error("[FilterGoals][getCoordinators]", error));
    },
    getMktManagers() {
      this.isLoadingSalesmans = true;
      this.$http.secured
        .get("/api/v1/users/", {params: {unpaged: true, q: {is_mkt_manager: true, anosafra_id: this.anosafra ? this.anosafra.id : null }},})
        .then((response) => { 
          this.users = response.data;
          if (this.$currentUser().is_mkt_manager && !this.$currentUser().is_admin) {
            this.users = this.users.filter((user) => user.id == this.$currentUser().id)
          }
          this.isLoadingSalesmans = false;
        })
        .catch((error) => console.error("[FilterGoals][getMktManagers]", error));
    },
    getSalesmans(salesmen_id=null) {
      this.isLoadingSalesmans = true;
      let params = { name_only: false, q: { anosafra_id: this.anosafra ? this.anosafra.id : null, is_salesman: true, status: true }, anosafra_id: this.anosafra.id}

      let manager = false
      let salesman = false
      if (this.$currentUser().is_manager && !this.$currentUser().is_admin) {
        params.q.manager_id = this.$currentUser().id
        manager = true
      }

      if (!this.$currentUser().is_manager && !this.$currentUser().is_admin) {
        params.q.id = this.$currentUser().id
        salesman = true
      }

      this.$http.secured
        .get("/api/v1/getsalesmans", { params: params })
        .then((response) => {
          this.users = response.data;
          let metaVegetal = { name: "VEGETAL", id: 0 };
          if (manager == false && salesman == false && this.selectedSalesmanJob.value == 'admin') {
            this.users.push(metaVegetal);
            this.selectedSalesman = metaVegetal
          } 
          this.isLoadingSalesmans = false;
        })
        .catch((error) => {
          this.isLoadingSalesmans = false;
          console.error("[FilterGoals][getSalesmans]", error);
        });
    },
  },
  computed: {
    enabledSalesmanFilter() {
      if (this.$currentUser().is_admin)   return true
      if (this.$currentUser().is_manager) return true
      
      return false
    },
    elabledSalesmanGoals() {
      if (this.enabledSalesmanFilter)    return true
      if (this.anosafraUsers.length > 0) return true

      return true;
    },
    selectedSalesman: {
      get() {
        return this.salesman;
      },
      set(val) {
        this.filter = { preferredproduct_name: "" };
        this.preferredname = "";
        this.salesman = val;
        this.$emit("salesman", val);
      },
    },
    selectedSalesmanJobInterface: {
      get() {
        return this.selectedSalesmanJob;
      },
      set(val) {
        this.$emit("update:selectedSalesmanJob", val);
      },
    },
    filteredJobs() {
      if (this.$currentUser().is_manager && !this.$currentUser().is_admin && !this.$currentUser().is_mkt_manager && !this.$currentUser().is_coordinator) {
        this.jobs = [
          { label: 'Gerentes Comerciais', value: 'manager' },
          { label: 'Vendedores', value: 'salesman' },
        ]
        this.job = this.jobs[0]
        return this.jobs
      } else if (this.$currentUser().is_admin) {
        this.jobs = [
          { label: 'Vegetal', value: 'admin' },
          { label: 'Gerente de Negócios', value: 'mkt' },
          { label: 'Gerente de sementes', value: 'seed_manager' },
          { label: 'Gerente de cereais', value: 'grain_manager' },
          { label: 'Gerente de nutrição', value: 'nutrition_manager' },
          { label: 'Gerente de irrigação', value: 'irrigation_manager' },
          { label: 'Gerente Comercial', value: 'manager' },
          { label: 'Vendedores', value: 'salesman' },
        ]
          this.job = this.jobs[0]
          this.toggleRoles(this.jobs[0])
          this.getSalesmans()
          return this.jobs
        } else if (this.$currentUser().job != null && this.$currentUser().job[0].value === 'mkt_manager') {
            this.jobs = [
              { label: 'Gerente de Negócios', value: 'mkt' },
              { label: 'Gerentes Comerciais', value: 'manager' },
              { label: 'Vendedores', value: 'salesman' },
            ]
            this.job = this.jobs[0]
            return this.jobs
          } else if (this.$currentUser().job != null && this.$currentUser().job[0].value === 'coordinator') {
            this.jobs = [
              { label: 'Gerentes Comerciais', value: 'manager' },
              { label: 'Vendedores', value: 'salesman' },
            ]
            this.job = this.jobs[0]
            return this.jobs
          } else if (this.$currentUser().job != null && this.$currentUser().job[0].value === 'seed_coordinator') {
            this.jobs = [
              { label: 'Coordenador de sementes', value: 'seed_coordinator' }
            ]
            this.job = this.jobs[0]
            return this.jobs
          } else if (this.$currentUser().job != null && this.$currentUser().job[0].value === 'seed_manager') {
            this.jobs = [
              { label: 'Gerente de sementes', value: 'seed_manager' },
            ]
            this.job = this.jobs[0]
            return this.jobs
          } else {
            this.jobs = [
              { label: 'Vendedores', value: 'salesman' },
            ]
              this.job = this.jobs[0]
              // this.selectedSalesman = this.$currentUser();
              this.getSalesmans(this.$currentUser().id)
              return this.jobs
          }
    }
  },
  watch: {
    filter: {
      handler(val) {
        console.log("changed Filter")
        this.$emit("filter", val);
      },
      deep: true,
    },
    elabledSalesmanGoals(val) {
      this.$emit("update:elabled-salesman-goals", val);
    },
    anosafra(newVal) {
      this.$emit("update:anosafra", newVal);

      if (!this.enabledSalesmanFilter) {
        this.getAnosafraUsers();
      }
    },
    enabledSalesmanFilter: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.salesman = this.$currentUser(); // update local data
          this.$emit("salesman", this.$currentUser()); // emit to parent
        }
      }
    }
  },
};
</script>